import { FunctionField, FunctionFieldProps } from 'react-admin';

import { resolvePath } from '@components';
import { moneyFormatter } from '@utils';
import { useListContext } from 'ra-core';

type ExtraProps = {sourceUsd?: string; nullable?: boolean};

export const MoneyUsdField = (props: Partial<FunctionFieldProps> & ExtraProps) => {
  const { filterValues } = useListContext(props);

  return (
    <FunctionField
      sortable={false}
      {...props}
      render={(record: any) => {
        const isUsd = record.isUsd && filterValues['isMixed'] !== false ? true : false;
        const source = isUsd && props.sourceUsd ? props.sourceUsd : props.source || '';
        const value = resolvePath(record, source);
        if (props.nullable && (value === null || value === undefined)) {
          return null;
        }

        return (
          <>
            {moneyFormatter.format(value)}{isUsd ? ' USD' : null}
          </>
        );
      }}
    />
  );
};
